module.exports = __webpack_public_path__ + "static/img/tourvirtual.b25e9297.jpg";